import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL_AUTH } from "../../constants";

interface AuthState {
  accessToken: string | null;
  loading: boolean;
}

const initialState: AuthState = { accessToken: null, loading: true };

export const refreshAccessToken = createAsyncThunk<
  string,
  void,
  { rejectValue: string }
>(
  "auth/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_URL_AUTH}/refresh`, {
        method: "POST",
        credentials: "include", 
      });

      if (!res.ok) throw new Error("Refresh failed");

      const data = await res.json();
      return data.accessToken as string;
    } catch {
      return rejectWithValue("Session expired");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
      state.loading = false;
    },
    clearAccessToken(state) {
      state.accessToken = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshAccessToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshAccessToken.fulfilled, (state, action) => {
        state.accessToken = action.payload;
        state.loading = false;
      })
      .addCase(refreshAccessToken.rejected, (state) => {
        state.accessToken = null;
        state.loading = false;
      });
  },
});

export const { setAccessToken, clearAccessToken } = authSlice.actions;
export default authSlice.reducer;
